
<div class="">
  <div class="page-content">
      <div class="row">
          <div class="col-6">
              <h2 class="heading1 d-none d-sm-block">{{'Language.SalesText' | translate}}</h2>
              <h2 class="heading1 d-block d-sm-none">{{'Language.TransporterMasterTest' | translate}}</h2>
          </div>
          <div class="col-6 text-end">
              <button *ngIf="canAdd" #buttonNewRow mat-raised-button (click)="onClickOfGenericNewButton()" class="primary-btn">
                {{'Language.CreateNewText' | translate}}
              </button>
          </div>
      </div>


      <div class="row mt-4 d-none d-sm-flex">
          <div class="col-md-6">
              <h3 class="heading2">{{'Language.TransporterMasterTest' | translate}}</h3>
          </div>
      </div>

      <div class="row">
          <div class="col-md-12 tabledesign">

            <app-chip [filterItems]='selectedFilters' (removeFilter)="onRemoveChip($event.index,$event.data)">
            </app-chip>

              <table mat-table [dataSource]="this.getListViewDataSource">
                  <!-- this.getListViewDataSource -->
                  <!-- Group Name Column -->
                  <ng-container matColumnDef="transporterName">
                      <th mat-header-cell *matHeaderCellDef > {{'Language.TransporterNameText' | translate }}
                          <i-feather class="t-icon" name="more-vertical" [matMenuTriggerFor]="menu1"></i-feather>
                            <mat-menu #menu1="matMenu" class="filtertrigger" xPosition="after">
                                <app-filter [colType]="'alphabets'" [shortColumn]="'transporterName'" 
                                [labelType]="'Language.TransporterNameText' | translate" [isActive]="this.active"
                                    (FilterColumn)="onClickOfGenericFilterButtonForRangeString($event.column, $event.formid, $event.toid,$event.label)"
                                    (sortFilter)="this.onClickOfGenericColumnSort('transporterName',this.active)">
                                </app-filter>
                            </mat-menu>
                      </th>
                      <td mat-cell *matCellDef="let row">
                          <!-- {{row.initialNumber}}  -->
                          {{row.transporterName}}
                      </td>
                  </ng-container>

                  <ng-container matColumnDef="transporterID">
                      <th mat-header-cell *matHeaderCellDef > {{'Language.TransporterIDText' | translate }}
                        <i-feather class="t-icon" name="more-vertical" [matMenuTriggerFor]="menu1"></i-feather>
                        <mat-menu #menu1="matMenu" class="filtertrigger" xPosition="after">
                            <app-filter [colType]="'alphabets'" [shortColumn]="'transporterID'" 
                            [labelType]="'Language.TransporterIDText' | translate" [isActive]="this.active"
                                (FilterColumn)="onClickOfGenericFilterButtonForRangeString($event.column, $event.formid, $event.toid,$event.label)"
                                (sortFilter)="this.onClickOfGenericColumnSort('transporterID',this.active)">
                            </app-filter>
                        </mat-menu>
                      </th>
                      <td mat-cell *matCellDef="let row">
                          <!-- {{row.lastNumber}}  -->
                          {{row.transporterID}}
                      </td>
                  </ng-container>

                  <!-- Star Column -->
                  <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef class="text-center">{{'Language.EditText' | translate }}</th>
                    <td mat-cell *matCellDef="let row" class="text-center">
                      <i-feather *ngIf="canEdit || canView" class="t-icon pointer" name="{{ !canEdit && canView ? 'eye' : 'edit-2' }}" (click)="onClickOfGenericEditButton(row.absEntry)">
                      </i-feather>
                    </td>
                  </ng-container>
        
                  <tr mat-header-row *matHeaderRowDef="this.getDisplayedColumnsNamesList"></tr>
                  <tr mat-row *matRowDef="let row; columns: this.getDisplayedColumnsNamesList;"></tr>
                </table>
          </div>
           <mat-paginator #paginator class="mt-3" [length]="this.getRowCount" [pageSize]="this.getPaginatorPageSize"
              [pageSizeOptions]="this.getPaginatorPageSizeOptions" aria-label="Select page"
              (page)="onClickOfGenericPaginator($event)" showFirstLastButtons>
            </mat-paginator>
      </div>

  </div>


</div>